import styled from "styled-components";
import { Button } from "../atoms/Button";
import { Input } from "../atoms/Input";
import { EmphasizedText, BodyText } from "../atoms/Text";
import { CheckinProgress } from "../molecules/CheckinProgress";
import { SeminarSelect } from "../molecules/SeminarSelect";
import { StatusFilterGroup } from "../molecules/StatusFilterGroup";
import { useEvent } from "../../contexts/EventContext";
import { IndustrySelect } from "../molecules/IndustrySelect";

const SearchRow = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

const Panel = styled.div`
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const TopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Field = styled.div`
  display: grid;
  gap: 4px;
`;

const FilterRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FilterRow3 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FilterRow2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const BottomRow = styled.div`
  /* プログレスは横いっぱい */
`;

export function VisitorListControlsPanel({
  total,
  checked,
  subUserTotal,
  subUserChecked,
  loading,
  onSearch,
  seminars,
  visitorName,
  onChangeVisitorName,
  companyName,
  onChangeCompanyName,
  address,
  onChangeAddress,
  industry,
  onChangeIndustry,
  status,
  onChangeStatus,
  selectedSeminarId,
  onChangeSeminar,
}) {
  // イベントが選択されているかを確認する用
  const { selectedEvent } = useEvent();
  const isEventSelected = !!selectedEvent;
  return (
    <>
      <SearchRow>
        <Button
          variant="primary"
          size="xl"
          fullWidth
          onClick={onSearch}
          disabled={loading || !isEventSelected}
        >
          {loading ? "検索中..." : isEventSelected ? "検索" : "イベント未選択"}
        </Button>
      </SearchRow>
      <Panel>
        <TopRow>
          <TopLeft>
            <EmphasizedText>検索結果絞り込み条件</EmphasizedText>
          </TopLeft>

          <TopRight>
            <StatusFilterGroup
              value={status}
              onChange={onChangeStatus}
            />
          </TopRight>
        </TopRow>

        
        <FilterRow3>
          <Field>
            <BodyText>氏名</BodyText>
            <Input
              value={visitorName}
              onChange={(e) => onChangeVisitorName(e.target.value)}
              placeholder="氏名で検索"
            />
          </Field>

          <Field>
            <BodyText>会社名</BodyText>
            <Input
              value={companyName}
              onChange={(e) => onChangeCompanyName(e.target.value)}
              placeholder="会社名で検索"
            />
          </Field>

          <Field>
            <BodyText>住所</BodyText>
            <Input
              value={address}
              onChange={(e) => onChangeAddress(e.target.value)}
              placeholder="住所で検索"
            />
          </Field>
        </FilterRow3>


        <FilterRow2>
          <Field>
            <BodyText>業種</BodyText>
              <IndustrySelect
                value={industry}
                onChange={onChangeIndustry}
              />
          </Field>

          <Field>
            <BodyText>セミナー</BodyText>
              <SeminarSelect
                seminars={seminars}
                value={selectedSeminarId}
                onChange={onChangeSeminar}
              />
          </Field>
        </FilterRow2>

        <BottomRow>
          
          <CheckinProgress
            label="受付進捗"
            total={total}
            checked={checked}
            subUserTotal={subUserTotal}
            subUserChecked={subUserChecked}
          />
        </BottomRow>
      </Panel>
    </>
    
  );
}